import { Controller } from '@hotwired/stimulus'
import { Toast } from 'bootstrap'

const STORAGE_KEY = 'notification_toast_shown'

export default class extends Controller {
  connect() {
    const notificationId = this.element.dataset.notificationId

    // Clean up old notifications from localStorage
    this.cleanupOldNotifications()

    // Check if the toast has already been shown
    if (this.hasAlreadyShown(notificationId)) {
      // Remove from DOM without showing
      this.element.remove()
      return
    }

    // Mark as shown in localStorage
    this.markAsShown(notificationId)

    // Criar instância do Bootstrap Toast e mostrar
    const toast = new Toast(this.element, {
      autohide: false,
    })
    toast.show()
  }

  closeToast(event) {
    // Prevent the click from propagating to the parent link
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()

    // Use Bootstrap API to hide
    const toast = Toast.getInstance(this.element)
    if (toast) {
      toast.hide()
    }

    // Remove after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  hasAlreadyShown(notificationId) {
    const shownIds = this.getShownIds()
    return shownIds.includes(String(notificationId))
  }

  markAsShown(notificationId) {
    const shownIds = this.getShownIds()
    shownIds.push(String(notificationId))

    // Keep only the last 100 to avoid filling localStorage
    if (shownIds.length > 100) {
      shownIds.shift()
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(shownIds))
  }

  getShownIds() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      return stored ? JSON.parse(stored) : []
    } catch (e) {
      console.error('Error reading localStorage:', e)
      return []
    }
  }

  // Clean up notifications from the previous day
  cleanupOldNotifications() {
    try {
      const stored = localStorage.getItem('toastedNotificationsData')
      if (!stored) {
        // First time, save today's date
        this.saveTodayDate()
        return
      }

      const data = JSON.parse(stored)
      const today = new Date().toDateString()

      // If the day changed, clear localStorage
      if (data.date !== today) {
        localStorage.removeItem(STORAGE_KEY)
        this.saveTodayDate()
      }
    } catch (error) {
      console.warn('Error cleaning up old notifications:', error)
    }
  }

  // Save today's date
  saveTodayDate() {
    try {
      const today = new Date().toDateString()
      localStorage.setItem('toastedNotificationsData', JSON.stringify({ date: today }))
    } catch (error) {
      console.warn('Error saving today date:', error)
    }
  }
}
